import React, { useContext } from 'react';
import { Linking, StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import { Affiliates } from './Affiliates';
import { Legal } from './Legal';
import { Location } from './Location';
import { Socials } from './Socials';
import { TopLinks } from './TopLinks';
import { HorizontalRule } from '../../common/HorizontalRule';
import { fetchPage } from '../../../common/Api';
import AppContext from '../../../contexts/App';
import LayoutContext from '../../../contexts/Layout';

const VALID_URI_SCHEMES = ['https', 'http', 'mailto', 'tel'];

const SiteFooter = ({ followContentLink }) => {
    const { state, dispatch } = useContext(AppContext);
    const { layout } = useContext(LayoutContext);
    const footer = state?.siteWrapper?.web.contentItems?.footer;

    const handleLinkPress = async (link, text) => {
        let supportedUrl = VALID_URI_SCHEMES.find(schema => schema === link.split(':')[0]);

        if (supportedUrl) {
            if (supportedUrl === 'mailto' && text) {
                return await Linking.openURL(`${link}?subject=${text}%20Website%20Connect`);
            }
            await Linking.openURL(link);
        }

        if (link.startsWith('/')) {
            await fetchPage(dispatch, link);
        }
    };

    const renderTopLinks = () => {
        const topLinks = footer?.contentItems?.['top Links']?.contentItems;

        if (layout.device.isMobile || layout.device.isTablet) {
            return (
                <View
                    style={StyleSheet.flatten(Styles.topLinksContainerMobile, {
                        marginHorizontal: layout.styleGuide.spacer1,
                        marginVertical: layout.styleGuide.spacer2
                    })}
                >
                    <TopLinks handleLinkPress={handleLinkPress} isMobile={true} topLinks={topLinks} />
                    <Socials {...footer} isMobile={true} />
                </View>
            );
        } else {
            return (
                <View style={StyleSheet.flatten(Styles.topLinksContainer, { marginHorizontal: layout.styleGuide.spacer1, marginVertical: layout.styleGuide.spacer2 })}>
                    <TopLinks handleLinkPress={handleLinkPress} isMobile={false} topLinks={topLinks} />
                    <Socials {...footer} isMobile={false} />
                </View>
            );
        }
    };

    if (!footer) {
        return null;
    }

    delete footer.key; //need to remove this to prevent React from complaining.

    return (
        <View
            style={{ borderTopColor: '#7f868b', borderTopWidth: StyleSheet.hairlineWidth, marginTop: layout.styleGuide.spacer1 }}
            dataSet={{ umbracoComponentName: footer.nodeTypeAlias }}
        >
            {renderTopLinks()}
            <HorizontalRule color={'#7f868b'} />
            <Location {...footer} followContentLink={followContentLink} isMobile={layout.device.isMobile} />
            <HorizontalRule color='#7f868b' />
            <Affiliates followContentLink={followContentLink} contentItems={footer.contentItems.affiliates.contentItems} handleLinkPress={handleLinkPress} />
            <HorizontalRule color='#7f868b' />
            <Legal followContentLink={followContentLink} {...footer} />
        </View>
    );
};

const Styles = StyleSheet.create({
    topLinksContainer: {
        alignItems: 'center',
        flex: 2,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    topLinksContainerMobile: {
        alignItems: 'center',
        justifyContent: 'center'
    }
});

SiteFooter.propTypes = {
    address: PropTypes.string,
    contentItems: PropTypes.shape({
        Affiliates: PropTypes.shape({
            contentItems: PropTypes.object
        }),
        'Top Links': PropTypes.shape({
            contentItems: PropTypes.object
        })
    }),
    email: PropTypes.string,
    facebookLink: PropTypes.shape({
        externalUrl: PropTypes.string
    }),
    legalText: PropTypes.string,
    phoneNumber: PropTypes.string,
    twitterLink: PropTypes.shape({
        externalUrl: PropTypes.string
    }),
    youtubeLink: PropTypes.shape({
        externalUrl: PropTypes.string
    })
};

export default SiteFooter;
